export class PublicPurchaseService {
}
//# sourceMappingURL=purchase.js.map